module.exports = __webpack_public_path__ + "static/media/user.a583942e.svg";